import { createModel } from '@rematch/core';
import { v4 as uuid } from 'uuid';
import { RecordModel, RecordIDModel } from '@equifinance/shared';
import { RootModel } from '.';

const fields = [
  'data',
] as const;
export type Chat = RecordIDModel<typeof fields[number]>;

const chatsModel = createModel<RootModel>()({
  ...RecordModel<Chat>(fields, {
    data: '[]',
  }),
  effects: (dispatch) => ({
    async createChat() {
      const id = uuid();
      dispatch.chats.CREATE(id);
      return id;
    },
  }),
});

export default chatsModel;
